// Module
var code = "<div class=\"progress\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" data-bind=\"attr: { 'aria-valuenow': progress, 'aria-label': label }\"> <div class=\"progress-bar\" data-bind=\"style: { width: widthStyle },\r\n                    css: { 'bg-success': isUploaded, 'bg-primary' : isUploading }\"> </div> </div> ";
// Exports
export default code;